import { render, staticRenderFns } from "./WorkExperienceModal.vue?vue&type=template&id=28bf4d2c&scoped=true&"
import script from "./WorkExperienceModal.vue?vue&type=script&lang=ts&"
export * from "./WorkExperienceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf4d2c",
  null
  
)

export default component.exports